import React, { useState, useEffect } from "react";
import {
  getAddresses,
  saveAddress,
  updateAddress,
  deleteAddress,
  apiRequest,
} from "../apiService/allApi";
import Swal from "sweetalert2";

const Address = () => {
  const [address, setAddress] = useState({
    name: "",
    mobile: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
  });

const profileData = JSON.parse(localStorage.getItem("profiledata")) ?? null;


  const [savedAddresses, setSavedAddresses] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    setLoading(true);
    
        const token = localStorage.getItem("token");
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        try {
          const res = await apiRequest(
            `api/customer/shipping/address/${profileData?._id}`,
            "GET",
            null,
            headers
          );
          if (res.data) {
            setLoading(false);
            setSavedAddresses(res.data?.shippingAddress);
setAddress(res.data?.shippingAddress)
          }
        } catch (e) {
          console.log(e);
          setLoading(false);
        } finally {
        }
  };

  const handleChange = (e) => {
    setAddress({
      ...address,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
       setLoading(true);
   
   
       try {
         const response = await apiRequest(
           `api/customer/shipping/address/${profileData?._id}`,
           "POST",
           address
         );
   
         if (response) {
           // Store token
           setShowForm(false)
           console.log(response);
           Swal.fire({
             icon: "success",
             text: response?.data?.message,
   
           });
   fetchAddresses()
           
         }
       } catch (e) {
         console.log(e);
         Swal.fire({
           icon: "error",
           title: "Error",
           text: e?.data?.message,
         });
       } finally {
         setLoading(false);
       }
  };

  const handleEdit = () => {
    setAddress(savedAddresses);
    setIsEditing(true);
    setEditingId(savedAddresses.id);
    setShowForm(true);
  };



  const handleAddNew = () => {
    setAddress({
      name: "",
      mobile: "",
      street: "",
      city: "",
      state: "",
      pincode: "",
    });
    setIsEditing(false);
    setEditingId(null);
    setShowForm(true);
  };

  return (
    <div style={styles.container}>
      <h4 className="title">Manage Addresses</h4>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Loading...</p>}

      {!showForm && (
        <button
          onClick={handleAddNew}
          style={styles.addButton}
          disabled={loading}
        >
          Add New Address
        </button>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">Full Name</label>
              <input
                type="text"
                name="name"
                className="form-control1"
                placeholder="Full Name"
                value={address.name}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">Mobile Number</label>
              <input
                type="text"
                name="mobile"
                className="form-control1"
                placeholder="Mobile Number"
                value={address.mobile}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">Street / House No.</label>
              <input
                type="text"
                name="street"
                className="form-control1"
                placeholder="Street / House No."
                value={address.street}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">City</label>
              <input
                type="text"
                name="city"
                className="form-control1"
                placeholder="City"
                value={address.city}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">State</label>
              <input
                type="text"
                name="state"
                className="form-control1"
                placeholder="State"
                value={address.state}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group m-b25">
              <label className="label-title">Pincode</label>
              <input
                type="text"
                name="pincode"
                className="form-control1"
                placeholder="Pincode"
                value={address.pincode}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="col-lg-12 d-flex gap-2">
            <button
              type="submit"
              className="add-cart-btn w-auto mt-3 mt-sm-0"
              disabled={loading}
            >
              {isEditing ? "Update Address" : "Save Address"}
            </button>

            <button
              type="button"
              className="add-cart-btn w-auto mt-3 mt-sm-0 bg-danger"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      <div style={styles.addressList}>
        <h4 className="title">Saved Addresses</h4>
        {!savedAddresses ? (
          <p>No addresses saved yet.</p>
        ) : (
            <div key={savedAddresses?.id} style={styles.addressItem}>
              <p>
                <strong>{savedAddresses?.name}</strong>
              </p>
              <p>
                {savedAddresses?.street}, {savedAddresses?.city}, {savedAddresses?.state} - {savedAddresses?.pincode}
              </p>
              <p>Mobile: {savedAddresses?.mobile}</p>
              <button className="add-cart-btn w-auto mt-3 mt-sm-0" onClick={() => handleEdit()} disabled={loading}>
                Edit
              </button>
             
            </div>
         
        )}
      </div>
    </div>
  );
};

const styles = {
  addButton: {
    padding: "10px",
    backgroundColor: "var(--primary-color)",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px",
  },
  addressList: {
    marginTop: "20px",
  },
  addressItem: {
    border: "1px solid #ddd",
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "4px",
  },
};

export default Address;
